import BaseService from "./geral/BaseService";

const base = "LiberacaoCabotagem";

export default class ContainersService extends BaseService {
    constructor() {
        super(base);
    };

    listarNavios = () => {
        return super.httpGet(`/${base}/ListarOperacoes`);
    };

    listarSituacoes = () => {
        return super.httpGet(`/${base}/ListarSituacoes`);
    };

    listar (operacao, cte, cntr, chave, situacao) {
        let filtros = "?";
        if (operacao) filtros = filtros.concat(`operacao=${operacao}`);
        if (cte) filtros = filtros.concat(`&cte=${cte}`);
        if (cntr) filtros = filtros.concat(`&cntr=${cntr}`);
        if (chave) filtros = filtros.concat(`&chave=${chave}`);
        if (situacao) filtros = filtros.concat(`&situacao=${situacao}`);
        filtros = filtros.replace("?&", "?");
        if (filtros.length===1) filtros = "";
        return super.httpGet(`/${base}/ListarCte${filtros}`);
    };

    salvar (cte) {
        return super.httpPost(`/${base}/SalvarCte`, cte);
    };

    xmlImporta(xmlDoc) {
        return super.httpPost(`/${base}/TransformarXlsEmCte`, xmlDoc)
    };

    inativar (cte) {
        return super.httpPost(`/${base}/InativarCte`, cte);
    };
}


// WEBPACK FOOTER //
// ./src/services/CabotagemService.js